'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconHourglass, iconHourglassTag } from '@ni/nimble-components/dist/esm/icons/hourglass';
import { wrap } from '../../utilities/react-wrapper';

export type { IconHourglass };
export { iconHourglassTag };
export const NimbleIconHourglass = wrap(IconHourglass);